import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ZoobinWithTextFarsi = (props: IconProps) => {
  const { size = 'md', fill = '#121D3A', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 64 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_5258_764)">
        <path
          className="text"
          d="M27.2156 3.60141V6.87798C27.2211 9.16707 25.3592 11.0391 23.0667 11.0518H22.7175C21.5595 11.0518 20.4431 10.568 19.6542 9.7249L19.4226 9.47758L19.191 9.7249C18.4003 10.568 17.2839 11.0518 16.1259 11.0518H14.9589C14.8847 11.05 14.4468 11.05 13.933 11.0464H13.7267L13.6417 11.2323C12.7949 13.0954 10.9222 14.2995 8.87215 14.2995H5.86134C2.97357 14.2995 0.625 11.9562 0.625 9.07681V4.97161C0.625 4.68819 0.8566 4.45711 1.14067 4.45711H1.82281C2.10688 4.45711 2.33848 4.68819 2.33848 4.97161V9.16888C2.33848 11.0536 3.87645 12.5863 5.76544 12.5863H8.9608C10.8498 12.5863 12.3878 11.0536 12.3878 9.16888V4.97342C12.3878 4.68819 12.6194 4.45711 12.9034 4.45711H13.591C13.8751 4.45711 14.1067 4.68819 14.1067 4.97161V9.4162H17.0324C17.8557 9.4162 18.5252 8.74825 18.5252 7.92865V5.16478C18.5252 4.87954 18.7568 4.65027 19.0408 4.64847H19.7266C20.0107 4.64847 20.2423 4.87954 20.2423 5.16297V7.92865C20.2423 8.74825 20.9099 9.4162 21.7332 9.4162H23.0269C24.3894 9.4162 25.4967 8.31137 25.4967 6.952V3.5996C25.4967 3.4624 25.551 3.33242 25.6487 3.23674C25.7446 3.13926 25.8749 3.08691 26.0124 3.08691H26.7018C26.8393 3.08691 26.9677 3.13926 27.0654 3.23674C27.1631 3.33423 27.2156 3.4624 27.2156 3.60141Z"
          fill={fill}
        />
        <path
          className="text"
          d="M44.915 4.84344V9.21401C44.915 12.0158 42.6297 14.2959 39.8216 14.2959H39.0074C38.7233 14.2959 38.4917 14.0648 38.4917 13.7814V13.0972C38.4917 12.8137 38.7233 12.5827 39.0074 12.5827H39.818C41.6798 12.5827 43.1943 11.0716 43.1943 9.21401V4.84344C43.1943 4.64486 43.3553 4.48238 43.5561 4.48238H44.5513C44.649 4.48238 44.7395 4.51849 44.8082 4.58709C44.877 4.65569 44.915 4.74595 44.915 4.84344Z"
          fill={fill}
        />
        <path
          className="text"
          d="M36.5557 3.08691H34.1239C31.9581 3.06525 30.1578 4.7279 30.0112 6.87438C30.0076 6.93215 30.0076 6.99533 30.0076 7.05851C30.004 9.25553 31.7952 11.0464 33.9991 11.0482H35.6474L35.1136 11.5861C34.4731 12.2288 33.6227 12.5827 32.7162 12.5827H31.9056C31.6215 12.5827 31.3917 12.8137 31.3917 13.0972V13.7814C31.3917 14.0648 31.6215 14.2959 31.9056 14.2959H32.7198C35.528 14.2959 37.8132 12.0158 37.8132 9.21401L37.8187 4.34699C37.8187 3.65196 37.2523 3.08691 36.5557 3.08691ZM36.0925 9.34038H33.9954C33.9556 9.34038 33.914 9.33858 33.8724 9.33677C33.2572 9.30428 32.6909 9.03349 32.2783 8.57495C31.8658 8.11821 31.6577 7.52608 31.6903 6.91229C31.7771 5.72622 32.7741 4.80012 33.9593 4.80012H36.0925V9.34038Z"
          fill={fill}
        />
        <path
          className="text"
          d="M8.09414 3.94261H6.55979C6.46286 3.94261 6.38428 4.02101 6.38428 4.11772V5.6486C6.38428 5.74531 6.46286 5.82371 6.55979 5.82371H8.09414C8.19107 5.82371 8.26965 5.74531 8.26965 5.6486V4.11772C8.26965 4.02101 8.19107 3.94261 8.09414 3.94261Z"
          fill={fill}
        />
        <path
          className="text"
          d="M44.6104 1.5H43.3896C43.3125 1.5 43.25 1.56252 43.25 1.63964V2.86036C43.25 2.93748 43.3125 3 43.3896 3H44.6104C44.6875 3 44.75 2.93748 44.75 2.86036V1.63964C44.75 1.56252 44.6875 1.5 44.6104 1.5Z"
          fill={fill}
        />
        <path
          className="text"
          d="M25.8604 13H24.6396C24.5625 13 24.5 13.0625 24.5 13.1396V14.3604C24.5 14.4375 24.5625 14.5 24.6396 14.5H25.8604C25.9375 14.5 26 14.4375 26 14.3604V13.1396C26 13.0625 25.9375 13 25.8604 13Z"
          fill={fill}
        />
        <path
          className="text"
          d="M18.3623 13H15.2627C15.1866 13 15.125 13.0625 15.125 13.1396V14.3604C15.125 14.4375 15.1866 14.5 15.2627 14.5H18.3623C18.4384 14.5 18.5 14.4375 18.5 14.3604V13.1396C18.5 13.0625 18.4384 13 18.3623 13Z"
          fill={fill}
        />
      </g>
      <g clip-path="url(#clip1_5258_764)">
        <path
          d="M58.9725 16H51.5087C51.2062 16 50.96 15.7537 50.96 15.4512V7.9875C50.96 7.75875 51.1012 7.55375 51.3162 7.47375L63.2575 2.99625C63.6987 2.83125 64.1287 3.26125 63.9637 3.7025L59.4862 15.6437C59.4062 15.8575 59.2012 16 58.9725 16Z"
          fill="#0F4F43"
        />
        <path
          d="M56.0125 13.04H48.5487C48.2462 13.04 48 12.7938 48 12.4913V5.02754C48 4.79879 48.1412 4.59379 48.3562 4.51379L60.2975 0.0362944C60.7387 -0.128706 61.1687 0.301294 61.0037 0.742544L56.5262 12.6838C56.4462 12.8975 56.2413 13.04 56.0125 13.04Z"
          fill="#BAEB30"
        />
      </g>
      <defs>
        <clipPath id="clip0_5258_764">
          <rect width="44.375" height="13" fill="white" transform="translate(0.625 1.5)" />
        </clipPath>
        <clipPath id="clip1_5258_764">
          <rect width="16" height="16" fill="white" transform="translate(48)" />
        </clipPath>
      </defs>
    </svg>
  );
};

ZoobinWithTextFarsi.displayName = 'ZoobinWithTextFarsi';
